const axios = require("axios")



export const races=(date)=>{
    const url = `https://ebayi.tjk.org/s/d/program/${date}/yarislar.json`
    return axios.get(url)
}

export const raceIn=(date,key)=>{
    const url = `https://ebayi.tjk.org/s/d/program/${date}/full/${key}.json`
    return axios.get(url)
}

